import { AlertCircle, CheckCircle2, RotateCcw } from "lucide-react";

// The invoice's own formats — always two decimals, and a two-digit day — which
// is what the printed invoice has always shown. Not utils/format, which drops
// the decimals of a round amount.

export function formatCurrency(amount) {
  return new Intl.NumberFormat("en-IN", {
    style: "currency",
    currency: "INR",
    maximumFractionDigits: 2,
  }).format(Number(amount) || 0);
}

export function formatDate(d, withTime = false) {
  if (!d) return "—";
  const date = new Date(d);
  return date.toLocaleDateString("en-IN", {
    day: "2-digit", month: "short", year: "numeric",
    ...(withTime ? { hour: "2-digit", minute: "2-digit" } : {}),
    timeZone: "Asia/Kolkata",
  });
}

export const STATUS_META = {
  success:             { label: "Paid",            tone: "paid",    Icon: CheckCircle2 },
  pending:             { label: "Pending",         tone: "pending", Icon: AlertCircle },
  failed:              { label: "Failed",          tone: "failed",  Icon: AlertCircle },
  refunded:            { label: "Refunded",        tone: "refund",  Icon: RotateCcw },
  partially_refunded:  { label: "Partial Refund",  tone: "refund",  Icon: RotateCcw },
};

// ⚠️ `Refunded` and `Failed` are the same family, differing by alpha — as the
// old stylesheet's rose and destructive did to the eye.
export const STATUS_TONE = {
  paid: "tw-border-success/25 tw-bg-success/[0.12] tw-text-success-fg",
  pending: "tw-border-warning/25 tw-bg-warning/[0.12] tw-text-warning-fg",
  failed: "tw-border-danger/30 tw-bg-danger/[0.12] tw-text-danger-fg",
  refund: "tw-border-danger/25 tw-bg-danger/10 tw-text-danger-fg",
};
